import Input from 'components/common/form/input/Input';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';

function JobPostContactForm() {
  return (
    <Row className="g-5">
      <Col xs={12}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="contactPersonName">Contact Person Name</FormLabel>
          <Input name="contactPersonName" id="contactPersonName" />
        </FormGroup>
      </Col>
      <Col xs={12}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="contactPersonEmail">Email Address</FormLabel>
          <Input name="contactPersonEmail" id="contactPersonEmail" />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default JobPostContactForm;
